/**
 * MKS-392 — upcoming team name days and birthdays for the dashboard card.
 *
 * `enabled` carries the release flag: with `mks_392_upcoming_celebrations`
 * off the card must behave exactly as it did before the ticket, which
 * includes making no request to an endpoint that 404s.
 *
 * `staleTime` is an hour — the answer only changes when the clock rolls over
 * a day or HR edits a birth date, and the card re-mounts on every dashboard
 * visit.
 */
import { useQuery } from '@tanstack/react-query';
import { fetchUpcomingCelebrations } from '../services/api/celebrations';

export function useUpcomingCelebrations(days: number, enabled = true) {
  return useQuery({
    queryKey: ['celebrations', 'upcoming', days],
    queryFn: () => fetchUpcomingCelebrations(days).then((r) => r.data),
    staleTime: 60 * 60 * 1000,
    enabled,
  });
}
